import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateCategoryPipe } from '@mwe/ui/pipes';
import { Sparte } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-invoice-list-item-subtitle',
  templateUrl: './invoice-list-item-subtitle.component.html',
  imports: [TranslateCategoryPipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceListItemSubtitleComponent {
  categories = input.required<Sparte[]>();
  invoiceDate = input.required<string>();
  priceColor = input.required<string>();
  isStorniert = input<boolean>(false);

  hasPriceColor = computed(() => this.priceColor().length > 0);
}
